import React, { FC, useEffect, useRef, useState } from 'react';
import { AutoComplete, Button, Input, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import { useOpenStreetMap } from 'modules/common';

import HouseLocationMap, { DEFAULT_CENTER } from './HouseLocationMap';

import styles from './houseLocationModal.module.scss';

interface IProps {
  setHouseLocationVisible: React.Dispatch<React.SetStateAction<boolean>>;
  houseLocationVisible: boolean;
  setLocation: React.Dispatch<
    React.SetStateAction<{
      lat: number;
      lng: number;
    }>
  >;
  location: {
    lat: number;
    lng: number;
  };
}

const HouseLocationModal: FC<IProps> = ({ houseLocationVisible, setHouseLocationVisible, location, setLocation }) => {
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const { t } = useTranslation();
  const [select, setSelect] = useState('');
  const { data } = useOpenStreetMap({ search: select });
  const [center, setCenter] = useState({
    lat: 0,
    lng: 0
  });

  const handleCancel = () => {
    setHouseLocationVisible(false);
  };

  const handleSave = () => {
    setLocation(center);
    handleCancel();
  };

  useEffect(() => {
    function myLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          position => {
            setCenter({
              lat: position.coords.latitude,
              lng: position.coords.longitude
            });
          },
          err => {
            setCenter(DEFAULT_CENTER);
          }
        );
      } else {
        setCenter(DEFAULT_CENTER);
      }
    }
    myLocation();
  }, []);

  useEffect(() => {
    if (location.lat && location.lng) {
      setCenter(location);
    }
  }, [location]);

  return (
    <Modal
      title={t('home.Lokatsiyani_biriktirish')}
      visible={houseLocationVisible}
      onCancel={handleCancel}
      footer={false}
      wrapClassName={styles.container}
    >
      <div className={styles.search}>
        <p>{t('profile.Manzil')}</p>
        <AutoComplete
          options={data?.map(item => ({
            ...item,
            value: item?.display_name
          }))}
          onSelect={(e: any, b: any) => {
            setCenter({
              lat: b?.lat,
              lng: b?.lon
            });
          }}
          onSearch={e => {
            if (timerRef.current) {
              clearTimeout(timerRef.current);
            }

            timerRef.current = setTimeout(() => {
              setSelect(e);
            }, 300);
          }}
        >
          <Input className="customInput" placeholder={t('home.Kocha_Kordinata_yoki_URL_orqali_izlang')} />
        </AutoComplete>
      </div>
      <div className={styles.map}>
        <HouseLocationMap center={center} setCenter={setCenter} />
      </div>

      <div className={styles.footer}>
        <Button onClick={handleCancel}>{t('one_lid.Bekor_qilish')}</Button>
        <Button type="primary" onClick={handleSave}>
          {t('one_lid.Saqlash')}
        </Button>
      </div>
    </Modal>
  );
};

export default HouseLocationModal;
